import BaseContainer from "@base/container/BaseContainer";
import TweenMax, {TweenLite} from "gsap";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";

export default class BulletContainer extends BaseContainer {

    constructor(data, endX) {
        super(data)

        Signals.roundEnd.add(() => this.stop(), this)

        this.bullet1 = new PIXI.Sprite(PIXI.Texture.from(data))
        this.bullet2 = new PIXI.Sprite(PIXI.Texture.from(data))
        this.bullet3 = new PIXI.Sprite(PIXI.Texture.from(data))

        this.endX = endX
       // this.image.rotation = 1.7
        this.addChild(this.bullet1)
        this.addChild(this.bullet2)
        this.addChild(this.bullet3)
        this.bullet2.visible = false
        this.bullet3.visible = false
    }

    position(x, y){
        this.bullet1.position.set(x, y)
        this.bullet2.position.set(x, y)
        this.bullet3.position.set(x, y)
    }

    async shooting() {

        this.bullet1.visible = true
        this.bullet2.visible = false
        this.bullet3.visible = false

        const pullBullet = (bullet, listBullet, endX) => {  return new Promise(resolve => {
            bullet.visible = true
            TweenMax.to(bullet, 0.4, {x: endX, ease: 'none', onComplete: () => {
                    bullet.visible = false
                //    listBullet.map( (bullet)=> { bullet.visible = true})
                    resolve()
                }
            })
        })}
        const pause = () => { return new Promise(resolve => {
            TweenLite.delayedCall(0.5, ()=>{ resolve() })
        })}
        try {
            this.shootingRun ? await pullBullet(this.bullet1, [this.bullet2, this.bullet3], this.endX + 100) : 0
            this.shootingRun ? await pause() : 0
            this.shootingRun ? await pullBullet(this.bullet2, [this.bullet3],this.endX + 180) : 0
            this.shootingRun ? await pause() : 0
            this.shootingRun ? await pullBullet(this.bullet3, [], this.endX + 150) : 0
        } catch (err) {
            console.log('Error shooting', err)
        }
    }

    start(){
        this.shootingRun = true
        this.shooting()
    }
    /*
    start() {
        this.bullet1.visible = true
        this.bullet2.visible = false
        this.bullet3.visible = false
        TweenMax.to(this.bullet1, 0.4, {x: this.endX + 100, onComplete: () => {
            this.bullet1.visible = false
            this.bullet2.visible = true
            TweenMax.to (this, 0.5,{ onComplete: ()=> {
                    TweenMax.to(this.bullet2, 0.4, {
                        x: this.endX + 180, onComplete: () => {
                            this.bullet2.visible = false
                            this.bullet3.visible = true
                            TweenMax.to(this, 0.5, {
                                onComplete: () => {
                                    TweenMax.to(this.bullet3, 0.4, {
                                        x: this.endX - 10, onComplete: () => {
                                            this.bullet3.visible = false
                                        }
                                    })
                                }
                            })
                        }
                    })
                }})
        }})
    }

     */

    stop() {
        console.log('BULLET STOP')
        this.shootingRun = false
        this.visible = false
        TweenMax.killTweensOf(this)
        TweenMax.killChildTweensOf(this)
        TweenMax.killTweensOf(this.bullet1)
        TweenMax.killTweensOf(this.bullet2)
        TweenMax.killTweensOf(this.bullet3)
    }
}
